var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraphicR = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 390,
  height: 162,
  viewBox: "0 0 390 162",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_599_7408)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.40985 115.453L896.59 115.453C897.369 115.453 898 116.084 898 116.862C898 117.641 897.369 118.271 896.59 118.271L1.40985 118.271C0.630859 118.271 -6.098e-05 117.641 -6.0912e-05 116.862C-6.08439e-05 116.084 0.63086 115.453 1.40985 115.453Z",
  fill: "#ECD8FB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.8987 39.736L689.234 39.736C690.013 39.736 690.644 40.3666 690.644 41.1451C690.644 41.9236 690.013 42.5542 689.234 42.5542L63.8987 42.5541C63.1197 42.5541 62.4888 41.9236 62.4888 41.1451C62.4888 40.3665 63.1197 39.736 63.8987 39.736Z",
  fill: "#ECD8FB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.5194 0.000146663L689.234 0.000198479C690.013 0.000198548 690.644 0.630762 690.644 1.40928C690.644 2.1878 690.013 2.81836 689.234 2.81836L96.5194 2.81831C95.7405 2.81831 95.1096 2.18774 95.1096 1.40923C95.1096 0.63071 95.7405 0.000146595 96.5194 0.000146663Z",
  fill: "#ECD8FB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.705 77.5946L896.59 77.5947C897.369 77.5947 898 78.2252 898 79.0038C898 79.7823 897.369 80.4128 896.59 80.4128L175.705 80.4128C174.926 80.4128 174.295 79.7822 174.295 79.0037C174.295 78.2252 174.926 77.5946 175.705 77.5946Z",
  fill: "#ECD8FB"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_599_7408"
}, /*#__PURE__*/React.createElement("rect", {
  width: 898,
  height: 449,
  fill: "white",
  transform: "translate(898 449) rotate(-180)"
})))));
export { SvgGraphicR as ReactComponent };
export default __webpack_public_path__ + "260106fe059194b883c05cb99da88b28.svg";